class Countdown extends HTMLElement {
  constructor() {
    super();
    this.intervalId = null;
    this.endTime = null;
  }

  connectedCallback() {
    this.render();
    this.startCountdown();
  }

  render() {
    const elements = [];

    const days = this.daysUntilToDate;
    const hours = this.hoursUntilToDate % 24;
    const minutes = this.minutesUntilToDate % 60;
    const seconds = this.secondsUntilToDate % 60;

    const textPrefix = this.querySelector('.cnt-Countdown_Prefix').innerHTML;
    const textSavings = this.querySelector('.cnt-Countdown_SavingsText').innerHTML;
    const textEl = this.querySelector('[data-el="countdown.text"]');

    if (this.timeIsUp()) {
      textEl.innerHTML = 'Ended';
      clearInterval(this.intervalId);
      return;
    }

    if (days > 0) {
      elements.push(`<span class="count"><span>${String(days).padStart(2, '0')}</span> days</span>`);
    }

    if (hours > 0 || days > 0) {
      elements.push(`<span class="count"><span>${String(hours).padStart(2, '0')}</span> hrs</span>`);
    }

    if (minutes > 0 || hours > 0 || days > 0) {
      elements.push(`<span class="count"><span>${String(minutes).padStart(2, '0')}</span> mins</span>`);
    }

    elements.push(`<span class="count"><span>${String(seconds).padStart(2, '0')}</span> secs</span>`);

    textEl.innerHTML = `${textPrefix} ${textSavings} ${elements.join(', ')}`;
  }

  startCountdown() {
    this.endTime = this.toDate.getTime();

    this.intervalId = setInterval(() => {
      this.render();
    }, 1000);
  }

  timeIsUp() {
    return Date.now() >= this.endTime;
  }

  get toDate() {
    const [date, time] = this.getAttribute('data-countdown-date').split(' ');
    const [year, month, day] = date.split('-');
    const [hour = '00', minute = '00', second = '00'] = (time || '00:00:00').split(':');

    return new Date(year, month - 1, day, hour, minute, second);
  }

  get now() {
    return new Date();
  }

  get daysUntilToDate() {
    return this.differenceInDays(this.toDate, this.now);
  }

  get hoursUntilToDate() {
    return this.differenceInHours(this.toDate, this.now);
  }

  get minutesUntilToDate() {
    return this.differenceInMinutes(this.toDate, this.now);
  }

  get secondsUntilToDate() {
    return this.differenceInSeconds(this.toDate, this.now);
  }

  differenceInDays(dateA, dateB) {
    const diffTime = dateA.getTime() - dateB.getTime();
    return Math.floor(diffTime / (1000 * 60 * 60 * 24));
  }

  differenceInHours(dateA, dateB) {
    const diffTime = dateA.getTime() - dateB.getTime();
    return Math.floor((diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  }

  differenceInMinutes(dateA, dateB) {
    const diffTime = dateA.getTime() - dateB.getTime();
    return Math.floor((diffTime % (1000 * 60 * 60)) / (1000 * 60));
  }

  differenceInSeconds(dateA, dateB) {
    const diffTime = dateA.getTime() - dateB.getTime();
    return Math.floor((diffTime % (1000 * 60)) / 1000);
  }
}

customElements.define('countdown-element', Countdown);